const angular = require('angular')
module.exports = angular
  .module('mw.service', [
    require('./domain.service'),
    require('./pref.service'),
    require('./reauthorization.service'),
  ]).name
